module.exports = __webpack_public_path__ + "static/media/brochure.7fed809b.pdf";